// extracted by mini-css-extract-plugin
module.exports = {"severity":"guideline_box_severity_DVMmt","box":"guideline_box_box_xKSOF"};